var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isLoading(_vm.data) && !_vm.isOK(_vm.data))?_c('span',[_c('span',{staticClass:"fa fa-spinner fa-spin text-smaller"})]):_c('span',[[_vm._t("default",[_vm._v(_vm._s(_vm.data[_vm.field] || _vm.$t('-NA-')))],{"data":_vm.data})]],2)}
var staticRenderFns = []

export { render, staticRenderFns }